import formatDate from "@lib/date/formatDate";

import type { TRangeDateValue, TSingleDateValue } from "../types";

const formatDateToTemplate = (value: TSingleDateValue | TRangeDateValue | undefined, template: string): string =>
  Array.isArray(value) ? value.map((date) => formatDate(date, template, "—")).join(" - ") : formatDate(value, template);

export default formatDateToTemplate;
